import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PathConstants } from './util/path.constants';
// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: PathConstants.PATH_EMPTY,
    redirectTo: PathConstants.FULLPATH_PAGINA_INICIO,
    pathMatch: 'full'
  },
  {
    path: PathConstants.PATH_SECURITY,
    component: SimpleLayoutComponent,
    loadChildren: './views/security/security.module#SecurityModule',

  },
  {
    path: PathConstants.PATH_ADMIN,
    component: FullLayoutComponent,
    data: {
      title: 'Administración'
    },
    children: [

      { path: PathConstants.PATH_BANNERES, data: { title: 'Banneres' }, loadChildren: './views/administration/banneres/banneres.module#BanneresModule' },
      { path: PathConstants.PATH_FOTOS, data: { title: 'Fotos' }, loadChildren: './views/administration/fotos/fotos.module#FotosModule' },
      { path: PathConstants.PATH_GALERIAS, data: { title: 'Galerias' }, loadChildren: './views/administration/galerias/galerias.module#GaleriasModule' },
      { path: PathConstants.PATH_HABITACIONES, data: { title: 'Habitaciones' }, loadChildren: './views/administration/habitaciones/habitaciones.module#HabitacionesModule' },
      { path: PathConstants.PATH_PLANES, data: { title: 'Planes' }, loadChildren: './views/administration/planes/planes.module#PlanesModule' },
      { path: PathConstants.PATH_PRECIOS, data: { title: 'Precios' }, loadChildren: './views/administration/precios/precios.module#PreciosModule' },
      { path: PathConstants.PATH_RESERVAS, data: { title: 'Reservas' }, loadChildren: './views/administration/reservas/reservas.module#ReservasModule' },
      { path: PathConstants.PATH_TIPOLOGIAS, data: { title: 'Tipologias' }, loadChildren: './views/administration/tipologias/tipologias.module#TipologiasModule' },
      { path: PathConstants.PATH_VALORES, data: { title: 'Valores' }, loadChildren: './views/administration/valores/valores.module#ValoresModule' },
      { path: PathConstants.PATH_VIDEOS, data: { title: 'Videos' }, loadChildren: './views/administration/videos/videos.module#VideosModule' },


    ]
  },
  {
    path: PathConstants.PATH_HOME,
    component: SimpleLayoutComponent,
    loadChildren: './views/pagina/pagina.module#PaginaModule',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/app.routing.ts